import Button, { ButtonProps } from "@mui/material/Button";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { Fragment, useCallback, useState } from "react";
import Menu from "@mui/material/Menu";
import { useStyles } from "./styles";
import { map } from "lodash";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Collapse from "@mui/material/Collapse";

type TOptions = {
  label: string;
  key?: string;
  onClick?: () => void;
};

type MenuButtonHeaderProps = ButtonProps & {
  label: string | React.ReactNode;
  options: {
    label: string;
    options?: TOptions[];
    key?: string;
    onClick?: () => void;
  }[];
};

export function MenuButtonHeader({
  options,
  label,
  ...rest
}: MenuButtonHeaderProps) {
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openSubmenu, setOpenSubmenu] = useState({});
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setOpenSubmenu({});
    setAnchorEl(null);
  };
  const handleClickOption = useCallback((_: any) => {
    _?.onClick();
    handleClose();
  }, []);

  const handleClickOptionSubmenu = useCallback((opt: any, idx: number) => {
    const key = `${opt.key}.${idx}`;
    setOpenSubmenu((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  return (
    <>
      <Button
        {...rest}
        endIcon={<KeyboardArrowDown />}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        {label}
      </Button>
      <Menu
        keepMounted
        classes={{ root: styles.root, paper: styles.paper }}
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {map(options, (option, index) => (
          <Fragment key={index.toString()}>
            <MenuItem
              onClick={() => {
                option.options
                  ? handleClickOptionSubmenu(option, index)
                  : handleClickOption(option);
              }}
              sx={{ padding: 1.5 }}
            >
              <ListItemText
                primary={option.label}
                classes={{ primary: styles.font }}
              />
              {option.options && (
                <ListItemIcon classes={{ root: styles.font }}>
                  <KeyboardArrowDown />
                </ListItemIcon>
              )}
            </MenuItem>
            <Collapse
              in={openSubmenu[`${option.key}.${index}`]}
              timeout="auto"
              unmountOnExit
            >
              {map(option.options, (opt, idx) => (
                <MenuItem
                  onClick={() => {
                    handleClickOption(opt);
                  }}
                  sx={{ padding: 1.5, paddingLeft: 4 }}
                  key={idx.toString()}
                >
                  <ListItemText
                    key={idx.toString()}
                    classes={{ primary: styles.font }}
                    primary={opt.label}
                  />
                </MenuItem>
              ))}
            </Collapse>
          </Fragment>
        ))}
      </Menu>
    </>
  );
}
